import { createContext } from 'react'

export type ModalType = 'success' | 'error' | 'warning' | 'info'

export interface ModalConfig {
  id: string
  type: ModalType
  title: string
  message?: string
  confirmText?: string
  cancelText?: string
  showCancel?: boolean
  onConfirm?: () => void | Promise<void>
  onCancel?: () => void
  onClose?: () => void
  autoClose?: boolean
  autoCloseDelay?: number
  closeOnOverlayClick?: boolean
}

export interface ModalContextType {
  modal: ModalConfig | null
  showModal: (config: Omit<ModalConfig, 'id'>) => void
  hideModal: () => void
  isVisible: boolean
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined)
